import {
  GET_DELIVERIES_SUCCESSFUL,
  GET_DELIVERIES_ERROR,
} from "../constants/DeliveriesConstants";
import Axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
  },
};
export const getDeliveries = (date) => (dispatch) => {
  Axios.get(`${API_ROOT}/deliveries?date=${date}`, config)
    .then((response) =>
      dispatch({ type: GET_DELIVERIES_SUCCESSFUL, payload: response.data })
    )
    .catch((error) => dispatch({ type: GET_DELIVERIES_ERROR, payload: error }));
};
